import React, { useState, useEffect } from "react";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

const AddRestaurantDrinks = ({ ownerId }) => {
  const [drinks, setDrinks] = useState([]);
  const [selectedDrinks, setSelectedDrinks] = useState([]);
console.log("drinks",drinks)
  // Fetch drinks from the API
  useEffect(() => {
    const fetchDrinks = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/extraitems/global/drinks`);
        setDrinks(response.data);
      } catch (error) {
        console.error("Error fetching drinks:", error);
      }
    };
    fetchDrinks();
  }, []);

  const handleDrinkChange = (e, drink) => {
    if (e.target.checked) {
      setSelectedDrinks([...selectedDrinks, drink]);
    } else {
      setSelectedDrinks(selectedDrinks.filter((d) => d._id !== drink._id));
    }
  };

  const handleSaveDrinks = async () => {
    try {
      const token = localStorage.getItem("ownerToken");
      if (!token) {
        alert("Please log in to select drinks.");
        return;
      }

      const drinkData = selectedDrinks.map((drink) => ({
        ownerId,
        drinkId: drink._id,
        price: drink.price,
        quantity: drink.quantity,
      }));

      await axios.post(`${API_URL}/api/extraitems/restaurant/drinks`, drinkData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Drinks updated successfully!");
    } catch (error) {
      console.error("Error updating drinks:", error);
      alert("Failed to update drinks. Please try again.");
    }
  };

  return (
    <div>
      <h2>Select Drinks</h2>
      <div>
        {drinks.map((drink) => (
          <div key={drink._id}>
            <input
              type="checkbox"
              value={drink._id}
              onChange={(e) => handleDrinkChange(e, drink)}
            />
            <label>
              <img src={drink.image} alt={drink.name} style={{ width: "50px", height: "50px" }} />
              {drink.name} - €{drink.price} (Qty: {drink.quantity})
            </label>
          </div>
        ))}
      </div>
      <button onClick={handleSaveDrinks}>Save Selected Drinks</button>
    </div>
  );
};

export default AddRestaurantDrinks;
